import { render } from "./CompanyAdminView.vue?vue&type=template&id=562a625a"
import script from "./CompanyAdminView.vue?vue&type=script&lang=js"
export * from "./CompanyAdminView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__